import { render, staticRenderFns } from "./EditConsent copy.vue?vue&type=template&id=ee73153e&scoped=true&"
import script from "./EditConsent copy.vue?vue&type=script&lang=js&"
export * from "./EditConsent copy.vue?vue&type=script&lang=js&"
import style0 from "./EditConsent copy.vue?vue&type=style&index=0&id=ee73153e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee73153e",
  null
  
)

export default component.exports